import { Grid, TextField } from "@mui/material";

const PositionFields = ({ positions, packSettings, handleChange, variant = "outlined" }) => {
    return (
      <>
        {positions?.length > 0 && positions.map((key) => (
          <Grid item xs={3} sx={{ p: 1 }} key={key}>
            <TextField
              id={key}
              label={key}
              fullWidth
              value={packSettings[key] ?? ""}
              onChange={handleChange}
              variant={variant}
            />
          </Grid>
        ))}
      </>
    );
  };
export default PositionFields;